export const PREVIEW_CHAR_LIMIT = 500;
export const PREVIEW_CHAR_LIMIT_IN_MOBILE_VIEW = 200;
